import styled from "styled-components/macro";

export const Styles = styled.div`
    a {
        margin-right: 10px;
    }

    a:hover {
        img {
            transform: scale(1.25);
        }
    }
`;
